import { Check } from 'lucide-react';
import { MBBS_COUNTRIES } from '@/data/content';
import { useCounsellingModal } from './CounsellingModal';

const MBBS_BENEFITS = [
  'NMC Approved Universities',
  'WHO Recognized Degrees',
  'English Medium',
  'Affordable Fees',
  'Hostel Facilities',
  'Indian Food Availability',
  'Clinical Exposure',
  'Visa Support',
];

const MBBSAbroad = () => {
  const { open } = useCounsellingModal();

  return (
    <section className="mbbs-section" data-testid="mbbs-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">MBBS Abroad</div>
          <h2 className="section-title">Pursue <span className="gold-gradient">MBBS Abroad</span> at Top Medical Universities</h2>
          <p className="section-subtitle">
            NMC and WHO approved medical universities across 6 countries. Affordable fees starting from ₹3–4 Lakhs per year with complete admission and visa support.
          </p>
        </div>

        {/* Benefits row */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: '12px', marginBottom: '60px',
          padding: '24px', background: 'rgba(212, 168, 73, 0.04)',
          border: '1px solid var(--border-subtle)', borderRadius: '6px'
        }}>
          {MBBS_BENEFITS.map((b, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: 'var(--text-secondary)' }}>
              <Check size={14} color="var(--gold)" strokeWidth={3} />
              <span>{b}</span>
            </div>
          ))}
        </div>

        <div className="mbbs-grid">
          {MBBS_COUNTRIES.map((country) => (
            <div key={country.id} className="mbbs-card" data-testid={`mbbs-${country.id}`}>
              <span className="mbbs-flag">{country.flag}</span>
              <h3>{country.name}</h3>
              <div className="mbbs-highlight">{country.highlight}</div>
              <div className="mbbs-details">
                <div className="mbbs-detail-row">
                  <span>Fees</span>
                  <span>{country.fee}</span>
                </div>
                <div className="mbbs-detail-row">
                  <span>Duration</span>
                  <span>{country.duration}</span>
                </div>
                <div className="mbbs-detail-row">
                  <span>Recognition</span>
                  <span>{country.recognition}</span>
                </div>
              </div>
              <button
                className="btn-secondary"
                onClick={() => open({ source: 'mbbs_card', course: 'MBBS', country: country.name })}
                data-testid={`mbbs-apply-${country.id}`}
                style={{ width: '100%' }}
              >
                Apply Now
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MBBSAbroad;
